export default __webpack_public_path__ + "static/media/marker-blue.4c17f469.svg";